import i18n from '../i18n/i18n';

const getSpeedMultiplier = (isMetric: boolean = false) => {
  return isMetric ? 3.6 : 2.23694;
};

const getSpeedUnit = (isMetric: boolean = false) => {
  return isMetric
    ? i18n.t('general.units.kphAbbrev')
    : i18n.t('general.units.mphAbbrev');
};

const getEnergyRatioFromFloat = (
  ratio?: number | null,
  hidePercentage?: boolean,
) => {
  if (ratio === null || ratio === undefined) {
    return null;
  }

  if (ratio > 1) {
    ratio = 1;
  } else if (ratio < 0) {
    ratio = 0;
  }

  if (hidePercentage) {
    return `${Math.round(ratio * 100)}`;
  }
  return `${Math.round(ratio * 100)}%`;
};

const getEnergyRatioDifference = (
  sessionRatio?: number | null,
  baselineRatio?: number | null,
) => {
  if (
    sessionRatio === undefined ||
    sessionRatio === null ||
    baselineRatio === undefined ||
    baselineRatio === null
  ) {
    return '';
  }

  const sessionRatioRounded = Math.round(sessionRatio * 100);
  const baselineRatioRounded = Math.round(baselineRatio * 100);
  const diff = sessionRatioRounded - baselineRatioRounded;
  if (diff > 0) {
    return `+${diff}%`;
  }
  return `${diff}%`;
};

const getEnergyRatio = ({ratio}: {ratio?: number | null}) => {
  if (ratio === null || ratio === undefined || ratio <= 0) {
    return null;
  }

  if (ratio > 1) {
    return 1;
  }

  return ratio;
};

const getComparisonFromStatDifference = (statDifference?: string) => {
  if (statDifference?.charAt(0) === '+') {
    return 'up';
  } else if (statDifference?.charAt(0) === '-') {
    return 'down';
  }
  return undefined;
};

const getComparisonFromBaseline = ({
  stat,
  baseline,
}: {
  stat?: number | null;
  baseline?: number | null;
}) => {
  if (stat && baseline) {
    return stat > baseline ? 'up' : 'down';
  }
  return undefined;
};

const inchesToCms = (inches: number) => {
  return inches * 2.54;
};

const lbsToKgs = (lbs: number) => {
  return lbs * 0.453592;
};

// Profile height is stored in inches regardless of preferred units
const getHeightLabel = (
  heightInches?: number | null,
  isMetric: boolean = false,
) => {
  if (!heightInches) {
    return null;
  }

  if (isMetric) {
    return `${Math.round(inchesToCms(heightInches))} ${i18n.t(
      'general.units.cmAbbrev',
    )}`;
  }

  return `${Math.floor(heightInches / 12)}' ${heightInches % 12}"`;
};

// Profile weight is stored in pounds regardless of preferred units
const getWeightLabel = (
  weightLbs?: number | null,
  isMetric: boolean = false,
) => {
  if (!weightLbs) {
    return null;
  }

  if (isMetric) {
    return `${Math.round(lbsToKgs(weightLbs))} ${i18n.t(
      'general.units.kgAbbrev',
    )}`;
  }

  return `${weightLbs} ${i18n.t('general.units.lbsAbbrev')}`;
};

export {
  getSpeedMultiplier,
  getSpeedUnit,
  getEnergyRatioFromFloat,
  getEnergyRatioDifference,
  getEnergyRatio,
  getComparisonFromStatDifference,
  getComparisonFromBaseline,
  inchesToCms,
  lbsToKgs,
  getHeightLabel,
  getWeightLabel,
};
